import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/shared/components'
import { AppVersionsPage } from '@/pages/app-versions/AppVersionsPage'

export const Route = createFileRoute('/app-versions')({
  component: () => (
    <RequirePermission section="appVersions" action="view">
      <AppVersionsPage />
    </RequirePermission>
  ),
})
